import React from 'react'
import { Outlet } from 'react-router-dom'
import { Box, Container, CssBaseline } from '@mui/material'
import Header from '../ui/Header/Header'
import Footer from '../ui/Footer/Footer'
import { useState } from 'react'
import { ToastContainer } from 'react-toastify'

export const Layout = () => {
    const [selected, setSelected] = useState(0);
    
    return (
        <>
            <CssBaseline />
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                minHeight: '100vh',
                position: 'relative'
            }}>
                {/* Header - вищий шар */}
                <Box sx={{ 
                    position: 'sticky',
                    top: 0,
                    zIndex: 1100, // Вищий z-index для Header
                    backgroundColor: 'background.paper',
                    boxShadow: 1
                }}>
                    <Header selected={selected} setSelected={setSelected}/>
                </Box>
                
                {/* Main контент */}
                <Box component="main" sx={{ 
                    zIndex: 1,
                    minHeight: '70vh',
                }}>
                    <Container maxWidth="xl" sx={{ pb: 2 }}>
                        <Outlet />
                    </Container>
                </Box>
                
                {/* Footer */}
                <Box sx={{ 
                    bottom: 0,
                    // position: 'sticky',
                }}>
                    <Footer selected={selected} setSelected={setSelected}/>
                </Box>
                
                {/* ToastContainer */}
                <ToastContainer
                    style={{ zIndex: 9999 }}
                    position="bottom-left"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
            </Box>
        </>
    )
}